/* tslint:disable */
/* eslint-disable */
import base64url from './base64url-arraybuffer';
import { PublicKeyExtendedCredentialRegister } from '../interfaces';

/**
 * @description PublicKeyCredentialToJSON.
 * @param {PublicKeyExtendedCredentialRegister} pubKeyCred - PubKeyCred.
 * @returns {PublicKeyExtendedCredentialRegister} PubKeyCred.
 */
function publicKeyCredentialToJSON(pubKeyCred: any) {
    if (pubKeyCred instanceof Array) {
        return pubKeyCred.map((x) => publicKeyCredentialToJSON(x));
    }

    if (pubKeyCred instanceof ArrayBuffer) {
        return base64url.encode(pubKeyCred);
    }

    if (pubKeyCred instanceof Object) {
        const obj = {};

        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in pubKeyCred) {
            obj[key] = publicKeyCredentialToJSON(pubKeyCred[key]);
        }

        return obj;
    }

    return pubKeyCred;
}

/**
 * @description GenerateRandomBuffer.
 * @param {number} length - Length.
 * @returns {ArrayBuffer} ArrayBuffer.
 */
function generateRandomBuffer(length: number) {
    const len = length || 32;

    const randomBuffer = new Uint8Array(len);
    window.crypto.getRandomValues(randomBuffer);

    return randomBuffer;
}

/**
 * @description CredReq.
 * @param {object} credReq - CredReq.
 * @returns {object} - Returns.
 */
const preformatMakeCredReq = (credReq) => {
    const makeCredReq = credReq;
    makeCredReq.challenge = base64url.decode(makeCredReq.challenge);
    makeCredReq.user.id = base64url.decode(makeCredReq.user.id);

    return makeCredReq;
};

/**
 * @description PreformatGetAssertReq.
 * @param {object} assert - PreformatGetAssertReq.
 * @returns {object} - Returns.
 */
const preformatGetAssertReq = (assert) => {
    const getAssert = assert;
    getAssert.challenge = base64url.decode(getAssert.challenge);

    getAssert.allowCredentials.forEach((allowCred) => {
        const ac = allowCred;
        ac.id = base64url.decode(ac.id);
    });

    return getAssert;
};

export {
    publicKeyCredentialToJSON,
    generateRandomBuffer,
    preformatGetAssertReq,
    preformatMakeCredReq,
};
